__turbopack_context__.v({
  "backgroundLayer": "SqReqG_backgroundLayer",
  "body": "SqReqG_body",
  "bottomFade": "SqReqG_bottomFade",
  "campaignAbove": "SqReqG_campaignAbove",
  "content": "SqReqG_content",
  "copy": "SqReqG_copy",
  "copyReveal": "SqReqG_copyReveal",
  "cta": "SqReqG_cta",
  "ctaGlass": "SqReqG_ctaGlass",
  "ctaRow": "SqReqG_ctaRow",
  "eyebrow": "SqReqG_eyebrow",
  "note": "SqReqG_note",
  "poster": "SqReqG_poster",
  "section": "SqReqG_section",
  "title": "SqReqG_title",
  "titleGroup": "SqReqG_titleGroup",
});
